module.exports = __webpack_public_path__ + "c_static/img/提现教程.2453b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/提现教程.png
// module id = F/Rt
// module chunks = 33